import "./index.scss";

import cx from "classnames";
import React from "react";

import { SimpleDropdown } from "@/components/components/Dropdown";
import { OptionVariant } from "@/components/components/Dropdown/dropdown.enum";
import { TDropdownOption } from "@/components/components/Dropdown/dropdown.type";

const baseClassName = "c-chategories-dropdown";

interface TChategoriesDropdownProps {
    isMobileView: boolean;
    options: TDropdownOption[];
    label?: string;

    onSelect: (o: TDropdownOption) => void;
}

const MoreIcon = (<svg xmlns="http://www.w3.org/2000/svg" height={18} width={18} viewBox="0 0 448 512"><path d="M336 176c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48zm-160 0c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48zM64 224c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM336 336c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48zM224 384c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zM16 336c0 26.5 21.5 48 48 48s48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48z"/></svg>);

function ChatCategoriesDropdown(props: TChategoriesDropdownProps) {
    const { options, onSelect, isMobileView, label } = props;
    
    const handleSelection = (o: TDropdownOption) => {
        onSelect(o);
    };

    const renderOverride = (_, toggleMenu: () => void) => 
    <button className={cx(
        `${baseClassName}__card`,
        `${baseClassName}__card__OTHERS`,
        )}
        onClick={toggleMenu}
        id={"OTHERS_CATEGORY_CARD"}
        >
        <div className={`${baseClassName}__icon`}>{MoreIcon}</div>
        <div className={`${baseClassName}__label`}>{label || "More"}</div>
    </button>;

    const optionClassNames = {
        icon: `${baseClassName}__dd-options`,
    };

    return <SimpleDropdown
        isMobileView={isMobileView}
        onSelect={handleSelection}
        options={options}
        optionsVariant={isMobileView ? OptionVariant.ACCENTED : OptionVariant.NORMAL}
        optionClassNames={optionClassNames}
        optionsContainerClassNames={{ menu: `${baseClassName}__menu`, container: `${baseClassName}__container` }}
        renderOverride={renderOverride}
        search={false}
    />;
}
export default ChatCategoriesDropdown;